import { Box, Button, Container, Typography } from "@mui/material";
import { IconUserPlus } from "@tabler/icons-react";
import { onSnapshot, query, where } from "firebase/firestore";
import { map, orderBy } from "lodash";
import { useEffect, useState } from "react";
import UsuarioDb from "../../../../db/usuarioDb";
import Business from "../../../../models/business";
import Usuario from "../../../../models/usuario";
import TabelaColaboradores from "../../../util/tabelas/tabelaUsuarios";
import CriarUsuario from "./criarUsuarioDialog";

type Props = { business: Business };

export default function Usuarios({ business }: Props) {
  const [usuarios, setUsuarios] = useState<Usuario[]>([]);
  const [openCriarUsuario, setOpenCriarUsuario] = useState(false);

  useEffect(() => {
    return onSnapshot(
      query(
        new UsuarioDb().collection({ usuarioId: "" }),
        where("business", "==", business.id)
      ),
      (query) =>
        setUsuarios(
          orderBy(
            map(query.docs, (doc) => doc.data()),
            "nome"
          )
        )
    );
  }, [business.id]);

  return (
    <Container sx={{ mt: 3, mb: 2, ml: 0 }} disableGutters maxWidth="md">
      <Box
        display="flex"
        flexDirection="row"
        width="100%"
        justifyContent="space-between"
        alignItems="center"
        mb={2}
      >
        <Box display="flex" alignItems="baseline" gap={1.5}>
          <Typography variant="eyebrow" color="text.secondary">
            02
          </Typography>
          <Typography variant="h3" color="text.primary">
            Colaboradores
          </Typography>
        </Box>
        <Button
          variant="contained"
          color="primary"
          startIcon={<IconUserPlus size={18} />}
          onClick={() => setOpenCriarUsuario(true)}
        >
          Adicionar colaborador
        </Button>
        <CriarUsuario
          open={openCriarUsuario}
          business={business}
          onClose={() => setOpenCriarUsuario(false)}
        />
      </Box>
      <TabelaColaboradores colaboradores={usuarios} />
    </Container>
  );
}
